<template>
  <!-- 指标管理页面 -->
  <div>
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="指标库维护" name="first"> </el-tab-pane>
        <!-- <el-tab-pane label="指标应用记录" name="second"></el-tab-pane> -->
        <!-- 指标库维护表格 -->
        <div v-if="activeName == 'first'">
          <el-row>
            <el-col :span="4">
              <h1>指标查询</h1>
              <el-menu
                border
                class="el-menu-vertical-demo"
                @select="selectMenu"
              >
                <el-menu-item index="1">
                  <el-icon></el-icon>
                  <span>共性指标</span>
                </el-menu-item>
                <el-menu-item index="3">
                  <el-icon></el-icon>
                  <span>*关键指标</span>
                </el-menu-item>
                <el-menu-item index="4">
                  <el-icon></el-icon>
                  <span>*加减分项</span>
                </el-menu-item>
                <el-menu-item index="5">
                  <el-icon></el-icon>
                  <span>*民主测评</span>
                </el-menu-item>
                <el-menu-item index="6">
                  <el-icon></el-icon>
                  <span>*服务对象评价</span>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="20">
              <div class="btn-group">
                <el-button type="primary" @click="handleAdd">添加</el-button>
                <!-- <el-button
                  type="primary"
                  @click="showableComp.showImportModel = true"
                  >导入</el-button
                > -->
                <!-- <el-button type="primary">下发指标</el-button> -->
              </div>

              <el-table
                :data="normItems"
                style="width: 100%"
                height="600"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                :default-sort="{ prop: 'normId' }"
                row-key="normId"
                :tree-props="{ children: 'children' }"
              >
                <el-table-column type="selection" width="55" fixed />
                <template v-for="column in normTable" :key="column.label">
                  <el-table-column
                    show-overflow-tooltip
                    :prop="column.prop"
                    :label="column.label"
                    width="180"
                    :formatter="formatter"
                    sortable
                  >
                  </el-table-column>
                </template>
                <el-table-column label="操作" width="200" fixed="right">
                  <template #default="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)"
                      type="text"
                      >编辑</el-button
                    >
                    <el-popconfirm
                      title="确认删除该指标?"
                      @confirm="deleteNormItem(scope.$index, scope.row)"
                      confirm-button-text="是"
                      cancel-button-text="否"
                    >
                      <template #reference>
                        <el-button size="mini" type="text">删除</el-button>
                      </template>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <!-- 指标应用记录表格 -->
        <div v-if="activeName == 'second'">
          <div class="left-group">
            <el-select v-model="selectOption" placeholder="请选择">
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <el-table
            border
            style="width: 100%"
            height="600"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'id' }"
            row-key="id"
            :tree-props="{ children: 'children' }"
          >
            >
            <el-table-column type="selection" width="55" fixed />
            <template v-for="column in tableColumns2" :key="column.label">
              <el-table-column
                :prop="column.prop"
                :label="column.label"
                width="180"
                sortable
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" width="200" fixed="right">
              <template #default="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 添加指标 -->
        <el-dialog
          v-model="showableComp.showAddModel"
          title="添加指标"
          width="46%"
        >
          <el-form :model="addModelForm" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="指标名称">
                  <el-input
                    v-model="addNormForm.normName"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="指标分类">
                  <el-select v-model="addNormForm.normType" placeholder="选择">
                    <el-option
                      v-for="item in normTypeArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上级指标">
                  <el-select
                    ref="selectTree"
                    v-model="addNormForm.parentNormName"
                    filterable
                    clearable
                    @focus="searchParentNorm"
                    @clear="clearHandle"
                  >
                    <el-option
                      :key="normId"
                      :label="normName"
                      :value="normId"
                      hidden
                    >
                    </el-option>
                    <el-tree
                      :data="parentNormList"
                      :props="defaultProps"
                      node-key="defaultProps.value"
                      @node-click="handleNodeClick"
                    ></el-tree>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标准分值">
                  <el-input
                    v-model="addNormForm.normScore"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="指标等级">
                  <el-input
                    v-model="addNormForm.level"
                    :rows="2"
                    placeholder="请输入标准内容"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="指标内容">
                  <el-input
                    v-model="addNormForm.normDetail"
                    :rows="4"
                    type="textarea"
                    placeholder="请输入标准内容"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="评价标准">
                  <el-input
                    v-model="addNormForm.evaCriterion"
                    :rows="2"
                    type="textarea"
                    placeholder="请输入评价标准"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="btn-bottom">
              <el-button type="primary" @click="doSubmit">确定</el-button>
              <el-button @click="onCancel">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 导入指标 -->
        <el-dialog title="导入指标" width="30%">
          <el-timeline>
            <el-timeline-item> 上传文件 </el-timeline-item>
            <el-timeline-item> 导入数据 </el-timeline-item>
            <el-timeline-item> 完成 </el-timeline-item>
          </el-timeline>
        </el-dialog>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
// @ is an alias to /src
import NormManage from "../api/NormManage";
export default NormManage;
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
}

.left-group {
  display: flex;
  justify-content: start;
  margin-bottom: 20px;
  width: 120px;
}

.el-select {
  width: 100%;
}

.el-timeline {
  display: block;
}

.btn-bottom {
  margin-top: 10px;
  text-align: end;
}
</style>